const AppConstants = {
  //size in MB
  MAX_PROFILE_PHOTO_FILE_SIZE: "10",
  MAX_PROFILE_VIDEO_FILE_SIZE: "25",
  MAX_SCHEDULE_ATTACHMENT_FILE: "10",
  MAX_CONTENT_GALLERY_FILE: "10",
  MAX_BADGE_SMALL_ICON_SIZE: "10",
  MAX_BADGE_MEDIUM_ICON_SIZE: "10",

  NA: "N/A",

  PROFILECOMPLETENESS_VALIDATION_MESSAGE: "(Your profile should complete atlease 60% for submition)",
  EDIT_SECTION_TITLE: {
    ContactDetails: "Contact Details",
    Events: "Events",
    //CurrentCoachingExp: "Current Coaching Experience",
    UpcomingSchedule: "Upcoming Schedule",
    Education: "Education",
    Employment: "Employment",
    Experience: "Officiating",
    GeneralInformation: "General Information",
    SelfAssessment: "Officiating Goals/Self-Assessment",
    Quiz: "Curriculum Analysis"
  },
  PROFILE_SECTION_TITLE: {
    ContactDetails: "Contact Details",
    Events: "Events",
    //CurrentCoachingExp: "Current Coaching Experience",
    UpcomingSchedule: "Schedule",
    Education: "Education",
    Employment: "Employment",
    Experience: "Officiating",
    GeneralInfo: "General Info",
    SelfAssessment: "Self Assessment",
    Quiz: "Curriculum Analysis",
    AboutUs: "About Us"
  },
  DASHBOARD_SECTION_TITLE: {
    AllProfiles: "All Prospects",
    RecentlyUpdatedProfiles: "Recently Modified",
    NoActivityProfiles: "No Recent Activity",
    NewCreated: "Recently Added",
    NoPrimaryScout: "No Primary Scout",
    NoEvaluation: "No Evaluation by Scout",
    AllEvaluated: "All Evaluated",
    ProspectsWatchList: "Prospects Watchlist",
    Archived: "Archived Profiles",
  },
  DASHBOARD_SECTION_ID: {
    All: 0,
    AllEvaluated: 1,
    NoPrimaryScout: 2,
    NoEvaluation: 3,
    NewCreated: 4,
    RecentlyUpdated: 5,
    Archived: 6,
    ProspectsWatchList: 7
  },
  MAP_FILTER_CATEGORY: [
    { value: 0, text: 'Prospects' },
    { value: 1, text: 'Events' },
    { value: 2, text: "Prospects by Pool" },
  ],
  QUIZ_STATUS_NAME: {
    IN_PROGRESS: "In Progress",
    TO_BE_DONE: "To be done",
    DONE: "Done"
  },
  APPROVAL_STATUS:
    [{ value: 0, text: 'Awaiting Approval' },
    { value: 1, text: 'Approved' },
    { value: 2, text: "Rejected" },
    ],
  IncompletedFields: {
    Country: "country",
    AboutUsSource: "aboutUsSource",
    RsvpResponse: "rsvpResponse",
  },
  COLORS: ['#fc4c4c', '#8f4ba0', '#00a2e2', '#fecc15', '#00b282', '#FF8042', "#1AFF33", "#999933", "#FF3380", "#CCCC00", "#66E64D", "#4D80CC", "#FF4D4D", "#99E6E6", "#6666FF", "#E6FF80"],

  CURRICULUM_STATUS_DRAFT: { id: 0, text: "Draft" },
  CURRICULUM_STATUS_PUBLISH: { id: 1, text: "Published" },

  CURRICULUM_ACCESS_PUBLIC: { id: 0, text: "Public" },
  CURRICULUM_ACCESS_PRIVATE: { id: 1, text: "Private" },
  CURRICULUM_STATUS: [{ id: -1, text: "All" }, { id: 0, text: "Draft" }, { id: 1, text: "Published" }],
  CURRICULUM_ACCESS: [{ id: -1, text: "All" }, { id: 0, text: "Public" }, { id: 1, text: "Private" }],
  STATUS: [{ id: -1, text: "All" }, { id: 0, text: "InActive" }, { id: 1, text: "Active" }],

  CURRICULUM_BADGE_DEFAULT_COLOR: "#000000",
  CURRICULUM_LEVEL_DEFAULT_COLOR: "#000000",
  PAGE_SIZES: [12, 24, 48, 72],
  DASHBOARD_PAGE_SIZE_OPTIONS: [10, 25, 50, 100, 200],
  ABOUT_US_CONFIG_KEY: 'HeardAboutusInfo',
  FILE_UPLOAD_FORMATS: ['application/vnd.ms-powerpoint', 'video/mp4', 'application/msword', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document', 'application/vnd.ms-excel', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
    'application/pdf', 'image/jpg', 'image/jpeg', 'image/png', 'image/svg+xml', 'image/bmp', 'text/plain'
  ],
  //['ppt', 'mp4', 'doc', 'docx', 'xls', 'xlsx', 'pdf', 'jpg', 'jpeg', 'png', 'svg', 'bmp', 'txt'],
  EVENT_CATEGORY_TYPE: {
    CLINIC_EVENT: 'ClinicEvent',
    VIRTUAL_PIPELINE: 'VirtualPipeline',
    INPERSON_PIPELINE: 'InPersonPipeline',
    REFEREE_OPERATIONS: 'RefereeOperationsEvent'
  },
  EVENT_TYPE: {
    SCOUTING_EVENT: 'ScoutingEvent',
    CLINIC_EVENT: 'ClinicEvent',
    PIPELINE_EVENT: 'PipelineEvent',
    REFEREE_OPERATIONS_EVENT: 'RefereeOperationsEvent'
  },

  EVENT_TYPE_LIST: [
    { displayName: "Scouting Event", value: "ScoutingEvent" },
    { displayName: "Clinic Event", value: "ClinicEvent" },
    { displayName: "Pipeline Event", value: "PipelineEvent" },
    { displayName: "Referee Operations Event", value: "RefereeOperationsEvent" }],

  EVENT_MODES: [
    { displayName: "In-Person", value: "In-Person" },
    { displayName: "Virtual", value: "Virtual" }],

  EVENT_STATUS: [
    { displayName: "Complete", value: 1 },
    { displayName: "InComplete", value: 0 }],

  HIRED_ACTIVE: 'Hired Active',
  HIRED_INACTIVE: 'Hired InActive',
  REQUEST_TIMEOUT_TIME: 10000,
  LIFE_CYCLE_AUDIT_CATEGORY: {
    PROFILE_CREATED: 1,
    PROFILE_COMPLETED: 2,
    CLINIC_ATTENDED: 3,
    ASSIGNED_PRIMARYSCOUT: 4,
    EVALUATED_BYSCOUT: 5,
    POOLID_UPDATE: 6,
    VIRTUAL_SESSION: 7,
    CURRICULUM_COMPLETED: 8,
    GRASSROOTS_ATTENDANCE: 9,
    MIDLEVEL_ATTENDANCE: 10,
    ELITE_ATTENDANCE: 11,
    HIRE_TO_GLEAGUE: 12,
    HIRE_TO_WNBA: 13,
    HIRE_TO_NBA: 14,
    NOLONGER_PROSPECT: 15,
    NOLONGER_CANDIDATE: 16,
    CAMP_ATTENDED: 17,
    VTS_ATTENDED: 18,
  },

  GLeague: "20",
  WNBA: "10",
  NBA: "00",
  FORM_ACTIONS_CONSTANTS: {
    CONTACT_US: 'contact_form',
    REGISTRATION: 'registration_form',
    EVENT_REGISTRATION: 'event_registration_form',
  },
  HeaderTypes: {
    MULTIPART_FORM_DATA: 'multipart/form-data',
    APPLICATION_JSON: 'application/json',
  },
  ROLES:
  {
    admin: "Admin",
    adminscout: "AdminScout",
    curriculumadmin: "CurriculumAdmin",
    eventadmin: "EventAdmin",
    otherinternal: "OtherInternal",
    participant: "Participant",
    partner: "Partner",
    scout: "Scout",
    user: "User",
    ynaadmin: "YnAAdmin",
  },

  EVENT_TYPES: {
    CAMP_EVENT: 'CampEvent',
    VTS_EVENT: 'VTSEvent',
  },

};

export default AppConstants;
